import { iconFactory } from '../iconFactory'

export const TwitterX = iconFactory(
  'TwitterX',
  ({ fill }) => (
    <path
      d="M11.8076 8.50936L18.8808 0.293488H17.2046L11.063 7.42722L6.15769 0.293488H0.5L7.91779 11.081L0.5 19.6966H2.17621L8.66194 12.1631L13.8423 19.6966H19.5L11.8072 8.50936H11.8076ZM9.51178 11.176L8.7602 10.1018L2.78017 1.55438H5.35474L10.1807 8.45242L10.9323 9.52661L17.2054 18.493H14.6309L9.51178 11.1764V11.176Z"
      fill={fill}
    />
  ),
  { viewBox: '0 0 20 20', height: '20px', width: '20px' },
)
